module.exports = __webpack_public_path__ + "img/altermedia-logo.17e2895b.png";